<template>
  <div>
    <!-- Worximity Forms, if the factory has at least one defined -->
    <fieldset v-if="isSelected && wxFormOptions.length > 0" class="ml-10">
      <h3 class="font-weight-bold mt-2 mb-2">{{ $t("alerts.wizard.deliveryMode.action.title") }}</h3>
      <wx-select
        v-model="reactiveValue.wxFormId"
        :items="wxFormOptions"
        item-text="name"
        item-value="id"
        :label="$t('alerts.wizard.deliveryMode.action.worximityForm')"
      />
    </fieldset>

    <fieldset v-if="isSelected && isNoFormSelected" class="ml-10">
      <h3 class="font-weight-bold mt-2 mb-2">{{ $t("alerts.wizard.deliveryMode.action.customActionTitle") }}</h3>
      <wx-textarea
        v-model="reactiveValue.message"
        :rules="actionMessageRules"
        :label="$t('alerts.wizard.deliveryMode.action.messageInput')"
        :placeholder="$t('alerts.wizard.deliveryMode.action.messageInput')"
        height="80"
        class="mt-2"
        counter
      />
      <wx-text-field
        v-model="reactiveValue.url"
        :rules="actionUrlRules"
        :label="$t('common.url')"
        :placeholder="$t('common.url')"
        class="mt-1"
      />
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WxTextarea from "@/components/ui/WxTextarea.vue";
import WxTextField from "@/components/ui/WxTextField.vue";
import WxSelect from "@/components/ui/WxSelect.vue";
import AlertService from "@/components/alerts/AlertService";

const actionMessageMaxLength = 500;

export default {
  name: "AttachedAction",
  components: { WxSelect, WxTextarea, WxTextField },
  props: {
    value: {
      type: Object,
      default: () => ({ wxFormId: null, message: null, url: null }),
    },
    alert: {
      type: Object,
      default: null,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      factoryForms: [],
      actionMessageRules: [
        (v) => {
          if (v && v.length > 0) {
            if (v.length <= actionMessageMaxLength) {
              return true;
            } else {
              return this.$t("alerts.wizard.deliveryMode.action.messageTooLong", { maxLength: actionMessageMaxLength });
            }
          } else {
            return true;
          }
        },
      ],
      actionUrlRules: [
        (v) => {
          if (v && v.length > 0) {
            try {
              new URL(v);
              return true;
            } catch (e) {
              return this.$t("alerts.wizard.deliveryMode.action.invalidUrl");
            }
          } else {
            return true;
          }
        },
      ],
    };
  },
  computed: {
    ...mapGetters("navigation", ["factoryUsers", "activeFactory"]),
    reactiveValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    wxFormOptions() {
      const list = [{ id: "0", name: this.$t("alerts.wizard.deliveryMode.action.noWorximityFormOption") }];
      list.push(...this.factoryForms);
      return list;
    },
    isNoFormSelected() {
      return this.reactiveValue.wxFormId === "0";
    },
  },
  methods: {
    async initializeData() {
      await AlertService.getForms(this.activeFactory.id).then((response) => {
        this.factoryForms = response.data;
      });

      if (!this.alert?.action_form_id && !this.alert?.action_message && !this.alert?.action_url) {
        this.reactiveValue = {
          wxFormId: null,
          message: null,
          url: null,
        };
      } else {
        this.reactiveValue = {
          wxFormId: this.alert?.action_form_id ?? "0",
          message: this.alert?.action_message ?? null,
          url: this.alert?.action_url ?? null,
        };
      }
    },
  },
  mounted() {
    this.initializeData();
  },
};
</script>
